import React from 'react';
import styles from '../../WabaChats.module.scss';

const SingleCheck = ({ color = '#667781' }) => (
    <svg viewBox="0 0 16 11" width="16" height="11" className={styles.statusIcon}>
        <path d="M11.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-2.011-2.095a.46.46 0 0 0-.36-.186.478.478 0 0 0-.344.153.507.507 0 0 0-.154.35.476.476 0 0 0 .14.36l2.328 2.428c.101.105.241.172.395.172a.546.546 0 0 0 .428-.202l6.529-8.06A.467.467 0 0 0 11.2.86a.504.504 0 0 0-.129-.207z" fill={color} />
    </svg>
);

const DoubleCheck = ({ color = '#667781' }) => (
    <svg viewBox="0 0 16 11" width="16" height="11" className={styles.statusIcon}>
        <path d="M11.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-2.011-2.095a.46.46 0 0 0-.36-.186.478.478 0 0 0-.344.153.507.507 0 0 0-.154.35.476.476 0 0 0 .14.36l2.328 2.428c.101.105.241.172.395.172a.546.546 0 0 0 .428-.202l6.529-8.06A.467.467 0 0 0 11.2.86a.504.504 0 0 0-.129-.207z" fill={color} />
        <path d="M15.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-1.2-1.25-.379.467 1.262 1.317c.101.105.241.172.395.172a.546.546 0 0 0 .428-.202l6.529-8.06a.467.467 0 0 0 .129-.207.504.504 0 0 0-.129-.207z" fill={color} />
    </svg>
);

const ClockIcon = () => (
    <svg viewBox="0 0 16 15" width="14" height="14" className={styles.statusIcon}>
        <path d="M9.75 7.713H8.244V5.359a.5.5 0 0 0-1 0v2.947a.5.5 0 0 0 .5.5h2.006a.5.5 0 0 0 0-1zM7.744.819A6.5 6.5 0 1 0 14.244 7.319 6.507 6.507 0 0 0 7.744.819zm0 11.882A5.382 5.382 0 1 1 13.126 7.319 5.388 5.388 0 0 1 7.744 12.7z" fill="#667781" />
    </svg>
);

const FailedIcon = () => (
    <svg viewBox="0 0 16 16" width="14" height="14" className={styles.statusIcon}>
        <circle cx="8" cy="8" r="7" fill="none" stroke="#e74c3c" strokeWidth="1.5" />
        <text x="8" y="12" textAnchor="middle" fill="#e74c3c" fontSize="12" fontWeight="bold">!</text>
    </svg>
);

export default function MessageStatus({ status }) {
    switch (status) {
        case 'pending': return <ClockIcon />;
        case 'sent': return <SingleCheck />;
        case 'delivered': return <DoubleCheck />;
        case 'read': return <DoubleCheck color="#53bdeb" />;
        case 'failed': return <FailedIcon />;
        default: return null;
    }
}
